import { render, staticRenderFns } from "./frackOil.vue?vue&type=template&id=dfa12418&scoped=true"
import script from "./frackOil.vue?vue&type=script&lang=js"
export * from "./frackOil.vue?vue&type=script&lang=js"
import style0 from "./frackOil.vue?vue&type=style&index=0&id=dfa12418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa12418",
  null
  
)

export default component.exports